// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const TABS = [
  'overview',
  'indications',
  'techSpecs',
]

const Tab = styled.button`
  padding: 15px;
  border: none;

  text-transform: lowercase;

  font-family: 'PF DIN', Helvetica, Arial, sans-serif;
  font-weight: 300;
  font-size: 27px;

  background: transparent;
  color: ${props => props.active ? '#B4B4B4' : props.color};
  cursor: ${props => props.active ? 'default' : 'pointer'};
  outline: none;

  &:first-child {
    padding-left: 0;
  }
`

type State = {
  selectedTabIndex: number
}

type Props = {
  overview: string,
  indications: string,
  techSpecs: string,
  color: ?string
}

class ProductContent extends Component {
  state: State;
  props: Props;

  state = {
    selectedTabIndex: 0,
  }

  renderContent() {
    const { selectedTabIndex } = this.state;
    const { overview, indications, techSpecs } = this.props;
    const selectedTab = TABS[selectedTabIndex];

    switch(selectedTab) {
      case 'overview':
        return (
          <div
            className="trix-content"
            dangerouslySetInnerHTML={{ __html: overview }}
          />
        )
      case 'indications':
        return (
          <div
            className="trix-content"
            dangerouslySetInnerHTML={{ __html: indications }}
          />
        )
      default:
        return (
          <div
            className="trix-content"
            dangerouslySetInnerHTML={{ __html: techSpecs }}
          />
        )
    }
  }

  render() {
    const { color } = this.props;
    const { selectedTabIndex } = this.state;

    return (
      <div>
        <nav>
          {TABS.map((tab, index) => (
            <Tab
              key={index}
              color={color}
              active={index === selectedTabIndex}
              onClick={() => this.setState({ selectedTabIndex: index })}
            >
              <FormattedMessage id={`productDrawer.tabs.${tab}`} />
            </Tab>
          ))}
        </nav>
        {this.renderContent()}
      </div>
    )
  }
}

export default ProductContent;



// WEBPACK FOOTER //
// ./src/components/ProductDrawer/ProductContent.js